import {
  LOGIN,
  LOGOUT,
  CHECK,
  REFRESH,
  RESET_STATE,
} from './mutationTypes';
import { $http } from '@/main';

export default {
  [LOGIN](state, response) {
    state.authenticated = true;
    state.user = response.user;
    localStorage.setItem('token', response.token);
    $http.defaults.headers.common.Authorization = `Bearer ${response.token}`;
  },
  [REFRESH](state) {
    state.authenticated = true;
  },
  [LOGOUT]() {
    localStorage.removeItem('token');
    $http.defaults.headers.common.Authorization = '';
  },
  [CHECK](state, response) {
    state.authenticated = true;
    state.user = response.user;
  },
  [RESET_STATE](state) {
    state.authenticated = false;
    state.user = Object.assign({});
  },
};
